import { Component, ContentChild, Directive, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef } from '@angular/core';
import { SelectionModel } from '../../models/selection.model';
import { Subscription } from 'rxjs';

export interface SelectionSelectAllContext {
  $implicit: string;
}

@Directive({
  selector: "[appSelectionSelectAll]"
})
export class SelectionSelectAllDirective {
  constructor(readonly _templateRef: TemplateRef<SelectionSelectAllContext>) {}

  get templateRef() {
    return this._templateRef;
  }
}

export interface SelectionListItemContext {
  $implicit: any;
}

@Directive({
  selector: "[appSelectionListItem]"
})
export class SelectionListItemDirective {
  constructor(readonly _templateRef: TemplateRef<SelectionListItemContext>) {}

  get templateRef() {
    return this._templateRef;
  }
}

@Component({
  selector: 'app-selection-list',
  templateUrl: './selection-list.component.html',
  styleUrls: ['./selection-list.component.scss']
})
export class SelectionListComponent implements OnInit, OnDestroy {
  private _subscription?: Subscription;
  public isAllSelected!: boolean;

  ngOnInit(): void {
    this.selectionModel = new SelectionModel<any>(this.multiple, [...this.selected])

    this.isAllSelected = this._isAllSelected();

    this._subscription = this.selectionModel.changed.subscribe(e => {
      this.changed.emit(e);
    })
  }
  
  ngOnDestroy(): void {
    this._subscription?.unsubscribe();
  }
  
  @ContentChild(SelectionSelectAllDirective, {static: true}) 
  _selectAllDirective?: SelectionSelectAllDirective;
  @ContentChild(SelectionListItemDirective, {static: true}) 
  _listItemDirective!: SelectionListItemDirective;
  
  @Input() data!: ReadonlyArray<any>;
  @Input() selected: ReadonlyArray<any> = [];
  @Input() multiple: boolean = false;
  @Output() changed = new EventEmitter<Array<any>>();

  selectionModel!: SelectionModel<any>;
  
  getItemContext(item: any): SelectionListItemContext {
    return {$implicit: item};
  }

  toggleAll() {
    if(!this.isAllSelected) {
      this.isAllSelected = true;
      this.selectionModel.select(...this.data)
      return;
    }

    this.isAllSelected = false;
    this.selectionModel.clear();
  }

  toggle(item: any) {
    this.selectionModel.toggle(item);
    this.isAllSelected = this._isAllSelected();
  }

  _isAllSelected() {
    return this.data.every(e => this.selectionModel.isSelected(e));
  }

  getSelectAllContext(): SelectionSelectAllContext {
    const text = "Select All";

    return {$implicit: text};
  }
}
